import { experienceBuilderApi } from 'api'

export const fetchGetBuilderProgress = () =>
  experienceBuilderApi.get<{ exists: boolean }>('/digital-profile/builder-progress')
